import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "grid md:grid-cols-3 gap-2 mb-4 lg:mb-12" }
const _hoisted_2 = { class: "md:col-span-2" }
const _hoisted_3 = { class: "grid md:grid-cols-2 lg:grid-cols-3 gap-3" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "basis-3/4 p-2 bg-black bg-opacity-60 dark:bg-opacity-80 text-white" }
const _hoisted_6 = { class: "font-bold text-xs" }
const _hoisted_7 = { class: "mt-1 text-xs" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import { Language, Recommendation, RecommendationActivity, RecommendationTopic } from "@/model";
import { computed, ref } from "vue";
import Heading from "@/components/Heading.vue";
import Listbox from "@/components/Listbox.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendationsView',
  async setup(__props) {

let __temp: any, __restore: any

const recommendations: Recommendation[] = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('recommendations').getFullList<Recommendation>(null, {
  sort: 'created',
}))),
  __temp = await __temp,
  __restore(),
  __temp
);

const languages = Object.keys(Language).map(language => ({
  key: language,
  label: Language[language],
}));
const selectedLanguages = ref(languages);

const topics = Object.keys(RecommendationTopic).map(topic => ({
  key: topic,
  label: RecommendationTopic[topic],
}));
const selectedTopics = ref(topics);

const activities = computed(() =>
    [...new Set(recommendations.map(recommendation => recommendation.activity))].sort((a, b) => a.localeCompare(b))
);

function getImageUrl(recommendation: Recommendation, file: string): string {
  return pb.files.getUrl(recommendation, file);
}

function filterRecommendations(activity: RecommendationActivity): Recommendation[] {
  return recommendations.filter(recommendation => {
    if (recommendation.activity !== activity) {
      return false;
    }

    if (!selectedLanguages.value.map(lang => lang.key).includes(recommendation.language)) {
      return false;
    }

    for (const topic of selectedTopics.value) {
      if (recommendation.topics.includes(topic.key)) {
        return true;
      }
    }

    return false;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, null, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("Recommendations")
      ])),
      _: 1,
      __: [2]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("p", null, " Recommendations for reading and watching from blogs to books to talks and conferences. ", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Listbox, {
            label: "Languages",
            optional: "",
            multiple: "",
            modelValue: selectedLanguages.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguages).value = $event)),
            options: _unref(languages)
          }, null, 8, ["modelValue", "options"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Listbox, {
              label: "Topics",
              optional: "",
              multiple: "",
              modelValue: selectedTopics.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTopics).value = $event)),
              options: _unref(topics)
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value, (activity) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createVNode(Heading, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(RecommendationActivity)[activity]), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterRecommendations(activity), (recommendation) => {
                return (_openBlock(), _createElementBlock("a", {
                  href: recommendation.url,
                  target: "_blank",
                  class: "flex justify-end rounded-lg bg-gray-100 dark:bg-gray-900 bg-no-repeat bg-center bg-cover",
                  style: _normalizeStyle(recommendation.image.length ? `background-image: url('${getImageUrl(recommendation, recommendation.image)}')` : '')
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "basis-1/4" }, null, -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(recommendation.title), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(recommendation.description), 1)
                  ])
                ], 12, _hoisted_4))
              }), 256))
            ])
          ], 64))
        }), 256))
      ]),
      _: 1,
      __: [4]
    })
  ], 64))
}
}

})